import { XIcon } from "@phosphor-icons/react/dist/csr/X";

import { useUndo } from "@/context/undo-context";

import styles from "./undo-toast.module.scss";

export function UndoToast() {
  const { undoItem, executeUndo, dismissUndo } = useUndo();

  if (!undoItem) return null;

  return (
    <div className={styles.toast} data-testid="undo-toast" role="status">
      <span className={styles.message}>
        Completed <strong>{undoItem.habitName}</strong>
      </span>
      <button
        type="button"
        className={styles.undoButton}
        onClick={executeUndo}
        data-testid="undo-button"
      >
        Undo
      </button>
      <button type="button" className={styles.dismiss} onClick={dismissUndo} aria-label="Dismiss">
        <XIcon size={20} aria-hidden="true" />
      </button>
    </div>
  );
}
